import { Moon, Sun } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useTheme } from '@/hooks/use-theme'

export function ThemeToggle() {
  const { theme, setTheme } = useTheme()

  return (
    <Button
      variant='ghost'
      size='icon'
      onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}
      className='w-10 h-10 rounded-full transition-all duration-300'
    >
      {theme === 'dark' && <Sun />}
      {theme === 'light' && <Moon />}
      <span className='sr-only'>Toggle theme</span>
    </Button>
  )
}
